module.exports = __webpack_public_path__ + "img/1.aa4d021c.png";